exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".terms-wrapper {\n  padding: 24px; }\n  .terms-wrapper .terms-inner {\n    max-width: 800px;\n    margin: 0 auto;\n    line-height: normal; }\n    .terms-wrapper .terms-inner .terms-header {\n      font-size: 36px;\n      font-weight: 600;\n      color: #222; }\n    .terms-wrapper .terms-inner .terms-sub {\n      margin-top: 8px;\n      font-size: 18px;\n      font-weight: 500;\n      color: #999; }\n    .terms-wrapper .terms-inner .terms-body {\n      font-size: 15px;\n      font-weight: 200;\n      color: #565656; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/terms/terms.component.scss
// module id = ../../../../../src/app/terms/terms.component.scss
// module chunks = main